import { useHideUI, useTopBarVisible } from '@/entities/playdeck/models/playdeck.store';

import { GameOrientation } from '@/shared/api/game/types';
import { isDesktop } from '@/shared/helpers/is-desktop';
import { useScreenOrientation } from '@/shared/hooks/use-orientation/use-screen-orientation';
import { useGame } from '@/shared/stores/app-store/app-store';

export const useIsTopBarVisible = () => {
  const isVisibleStore = useTopBarVisible();
  const hideUI = useHideUI();
  const screenOrientation = useScreenOrientation();

  const game = useGame();

  const isFullscrenGame = !!game?.flags?.fullscreen;

  // Если hideUI включен, топбар никогда не показывается
  if (hideUI) return false;

  if (isVisibleStore) {
    if (isDesktop()) return true;

    if (isFullscrenGame) return false;

    return screenOrientation === GameOrientation.PORTRAIT;
  }

  return false;
};
